module.exports = __webpack_public_path__ + "img/img_1.e23c3bf7.png";